export class RequestsInterceptor {
  #isEnterprise = false;

  constructor () {
    this.#isEnterprise = INKIVE.C.WHITE_LABEL_CONFIGURATION?.has_account_manager ?? false;
  }

  registerInterceptors () {
    this.registerFetchInterceptor();
    this.registerJQueryInterceptor();
  }

  registerJQueryInterceptor = () => {
    const isEnterprise = this.#isEnterprise;

    $.ajaxSetup({
      beforeSend: (xhr) => {
        if (isEnterprise) {
          xhr.setRequestHeader('X-Client-Type', 'enterprise');
        }
      }
    });

    $(document).ajaxError(function (event, request, settings) {
      const error = request && request.statusText;
      const url = settings.url;

      if (!INKIVE.C.IS_MOBILE_APP &&
        url.match(/(\/api\/|\/updateSettings)/) &&
        url.match(/^((?!\/errortrack\/).)*$/)) {
        if (_.contains([
          'Internal Server Error',
          'Permission is not granted',
          'Forbidden'
        ], error)) {
          INKIVE.Modal.togglePageLoader(false);
          INKIVE.Helpers.displayAccessModal();
        }
      }
    });
  };

  registerFetchInterceptor = () => {
    const { fetch: originalFetch } = window;
    const isEnterprise = this.#isEnterprise;

    window.fetch = async function (...args) {
      const [resource, config] = args;

      try {
        if (isEnterprise) {
          if (config?.headers && resource.includes('https://api.')) {
            if (config.headers instanceof Headers) {
              config.headers.set('X-Client-Type', 'enterprise');
            } else {
              config.headers['X-Client-Type'] = 'enterprise';
            }
          } else if (resource instanceof Request && resource.url.includes('https://api.')) {
            resource.headers.set('X-Client-Type', 'enterprise');
          }
        }
      } catch (error) {
        console.error('Error while setting X-Client-Type header', error);
      }

      try {
        return await originalFetch(resource, config);
      } catch (error) {
        throw new Error(JSON.stringify({
          message: 'Fetch error: ' + error.message,
          resource,
        }));
      }
    };
  };
}

const instance = new RequestsInterceptor();
instance.registerInterceptors();

export default instance;
